export const CREATE_SELLER_LOCATION = "CREATE_SELLER_LOCATION";
export const GET_SELLER_LOCATION = "GET_SELLER_LOCATION";
export const SET_SELLER_LOCATIONS = "SET_SELLER_LOCATIONS";
export const GET_LOCATION_COUNTRIES = "GET_LOCATION_COUNTRIES";
export const SET_SUPLIER_LIST = "SET_SUPLIER_LIST";
export const SET_SUPLIER_LOCATION_LIST = "SET_SUPLIER_LOCATION_LIST";
export const UPDATE_SELLER_LOCATION = "UPDATE_SELLER_LOCATION";